var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map-style-1"},[_c('iframe',{attrs:{"title":"Our Location","src":"//www.google.com/maps/embed/v1/place?q=place_id:ChIJhVkJ6tUAdkgRlGVb4ExnZYs&key=AIzaSyBpuLDyB4by1-_k8D7JfwVB_MGXk_1h0z4","allowfullscreen":""}})])
}]

export { render, staticRenderFns }